import { render, staticRenderFns } from "./MyRewards.vue?vue&type=template&id=cbd9efbe&scoped=true&"
import script from "./MyRewards.vue?vue&type=script&lang=js&"
export * from "./MyRewards.vue?vue&type=script&lang=js&"
import style0 from "./MyRewards.vue?vue&type=style&index=0&id=cbd9efbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd9efbe",
  null
  
)

export default component.exports